import { html, nothing } from 'lit';
import { BaseElement } from '../base.js';

export class AccountsList extends BaseElement {
  static properties = {
    items: { state: true },
    base_path: { attribute: 'base-path' },
    show_migration: { type: Boolean },
    show_roles: { type: Boolean }
  };

  constructor() {
    super();
    this.items = [];
    this.base_path = '/accounts/';
    this.show_migration = true;
    this.show_roles = false;
  }

  render() {
    return html`
      <div class="list-group">
        ${this.items.length === 0
          ? html`<p class="m-3">No accounts found</p>`
          : nothing}
        ${this.items.map(
          (item) => html`
            <a
              href="${this.base_path}${item.account}/"
              class="list-group-item list-group-item-action hstack"
            >
              <span class="badge ${statusBadgeClass(item.status)} me-2">
                ${item.status}
              </span>
              ${this.show_roles
                ? html`<span class="badge text-bg-secondary me-2">
                    ${item.roles?.map(({ name }) => name).join(', ') ||
                    'NO ROLE'}
                  </span>`
                : nothing}
              ${this.show_migration
                ? html`
                    <span
                      class="badge ${item.features.includes('MIGRATED')
                        ? 'text-bg-primary'
                        : 'text-bg-secondary'} me-2"
                    >
                      ${item.features.includes('MIGRATED')
                        ? 'MIGRATED'
                        : 'NOT MIGRATED'}
                    </span>
                  `
                : nothing}
              <div class="me-auto">${item.display_name}</div>
              <small class="d-none d-lg-block text-muted ms-2">
                ${item.email}
              </small>
            </a>
          `
        )}
      </div>
    `;
  }
}

function statusBadgeClass(status) {
  switch (status) {
    case 'ACTIVE':
      return 'text-bg-success';
    case 'INACTIVE':
      return 'text-bg-danger';
    case 'PENDING':
      return 'text-bg-warning';
    default:
      return 'text-bg-secondary';
  }
}

customElements.define('accounts-list', AccountsList);
